import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {
  DialogActions,
  Grid,
  FormControl,
  InputLabel,
  Switch,
  FormControlLabel
} from '@mui/material';

interface ActiveHomeDialogProps {
  modalOpen: boolean;
  onClose: (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void;
  handleConfirm: any;
  address: any;
}

export default function ActiveHomeDialog({
  modalOpen,
  onClose,
  handleConfirm,
  address
}: ActiveHomeDialogProps) {
  const currentEnabledValue = address?.enabled;
  const [selectedEnabledValue, setSelectedEnabledValue] = useState(false);

  function handleSwitch(event) {
    setSelectedEnabledValue(event.target.checked);
  }

  useEffect(() => {
    if (currentEnabledValue !== undefined) {
      setSelectedEnabledValue(address?.enabled);
    }
  }, [currentEnabledValue]);

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={modalOpen}
      classes={{
        scrollPaper: 'flex items-center justify-center h-30%',
        paper: 'm-auto w-full max-w-[500px] mt-70%'
      }}>
      <DialogContent dividers>
        <>
          <FormControl fullWidth className="-left-3">
            <InputLabel htmlFor="address-label">
              Address: {address?.address}
            </InputLabel>
          </FormControl>
          <FormControl fullWidth className="-left-3">
            <InputLabel htmlFor="enabled-label">
              Enabled: {currentEnabledValue?.toString()}
            </InputLabel>
          </FormControl>
          <FormControlLabel
            label="Confirm Active"
            className="mt-4"
            control={
              <Switch
                checked={selectedEnabledValue}
                onChange={evt => {
                  handleSwitch(evt);
                }}
                color="primary"
              />
            }
          />
        </>
      </DialogContent>
      <DialogActions>
        <Grid container>
          <Button
            onClick={() => handleConfirm(address, selectedEnabledValue)}
            className="float-right m-2.5"
            variant="contained"
            color="primary">
            {'Set address active state'}
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
